import {
  DEFAULT_K8_REPORT_UNIT_SECTION,
  K8_REPORT_UNIT_SECTION,
} from 'pages/K8Report/flag.on/constants'
import {
  MOCK_REPORT_TABLE_BY_UNIT_SECTION,
  getDefaultMockReportTableData,
} from './mockReportTableData'

/**
 * School summary report table payload for the active K-8 unit section (core vs specialized).
 * Uses mock data until wired to reportsManager / API.
 *
 * @param {object} _state - Redux root state (reserved for real selectors).
 * @param {string} [k8ReportUnitSection] - Route param after `/reports/k8/`.
 */
export const selectSchoolSummaryReportTableData = (
  _state,
  k8ReportUnitSection,
) => {
  const section =
    k8ReportUnitSection === K8_REPORT_UNIT_SECTION.SPECIALIZED_UNITS ||
    k8ReportUnitSection === K8_REPORT_UNIT_SECTION.CORE_UNITS
      ? k8ReportUnitSection
      : DEFAULT_K8_REPORT_UNIT_SECTION

  return (
    MOCK_REPORT_TABLE_BY_UNIT_SECTION[section] || getDefaultMockReportTableData()
  )
}
